<script setup>
import { computed, ref } from 'vue'
import { Link, usePage } from '@inertiajs/vue3'
import Popover from 'primevue/popover'
import CreditsCounter from '../CreditsCounter.vue'

const page = usePage()

const items = computed(() => page.props.menu ?? [])

const collapsedItems = computed(() => {
    const arr = [...items.value]
    const idx = arr.findIndex(i => i.selected)
    if (idx > 1) {
        const sel = arr.splice(idx, 1)[0]
        arr.splice(1, 0, sel)
    }
    return arr.slice(2)
})

const op = ref()
</script>

<template>
    <template v-if="collapsedItems.length">
        <button
            class="text-neutral-700 dark:text-neutral-200 flex items-center justify-center w-10 h-10 rounded-full hover:bg-neutral-100 dark:hover:bg-neutral-800 transition"
            @click="(event) => op.toggle(event)"
        >
            <i class="pi pi-bars !text-lg"/>
        </button>
        <Popover ref="op" class="!min-w-[220px]">
            <div class="flex flex-col gap-3">
                <CreditsCounter horizontal/>
                <template v-for="item in collapsedItems" :key="item.label">
                    <Link
                        :href="item.route"
                        prefetch
                        class="flex items-center gap-3 rounded hover:bg-neutral-50 dark:hover:bg-neutral-800 transition text-neutral-800 dark:text-neutral-200 text-sm"
                        @click="op.hide()"
                    >
                        <i :class="item.icon + ' text-lg w-6 flex justify-center items-center'"/>
                        <span class="grow">{{ item.label }}</span>
                        <div v-if="item.needsUpgrade" class="ml-4 text-black bg-yellow-500 rounded-full w-5 flex justify-center items-center h-5 p-1">
                            <i class="pi pi-crown !text-xs"/>
                        </div>
                    </Link>
                    <template v-if="item.icon === 'pi pi-link'">
                        <hr class="border-neutral-300 my-0.5"/>
                    </template>
                </template>
            </div>
        </Popover>
    </template>
</template>
